<script lang="ts">
    export let label: string = 'ENABLE';
    export let label2: string = 'DISABLE';
    export let bgColor: string = 'black';
    export let color: string = 'white';
    export let onBeforeClick: ((state: boolean, e: Event) => boolean)|undefined = undefined;

    let btnElement: HTMLButtonElement;

    let state: boolean = false;

    function handleClick(e) {
        if (!onBeforeClick || (onBeforeClick && onBeforeClick(state, e))) {
            state = !state;
        }
    }
</script>


<button
    class="ivdemo-text-button"
    bind:this={btnElement}
    style={`background-color:${bgColor};color:${color}`}
    on:click={handleClick}
>
    {#if !state}
    {label}
    {:else}
    {label2}
    {/if}
</button>


<style>
    .ivdemo-text-button {
        font-size: 0.8rem;
        font-weight: bold;
        user-select: none;
        -webkit-user-select: none;
        border: 0;
        padding: 0;
        margin: 0;
        border-radius: 0;
    }
    .ivdemo-text-button:hover {
        filter: invert(1);
    }
</style>

